import VisitorsDataTable from "../../../components/dataTable/tables/visitor/VisitorsDataTable";

function VisitorsPageView() {
  return <VisitorsDataTable />;
}

export default VisitorsPageView;
